<template>
    <Internal>

        <BreadcrumbsComponent :pages="pages" :is-dashboard="false"/>
        <div class="grid gap-4 grid-cols-9 -mt-4">
            <div class="col-span-9">
                <Table :fields="fields"
                       :items="presentations"
                       :canView="true"
                       :empty_message="`${_type} not found`"
                >
                    <template #teacher="{item}">

                        <inertia-link class="text-blue-600 hover:!underline"
                                      :href="route('administrative.faculty.view',item.faculty.id)"
                                      v-if="hasRole('View Faculty')">
                            {{ item.faculty.first_name }} {{ item.faculty.middle_name }} {{ item.faculty.last_name }}
                        </inertia-link>
                        <p v-else class="cursor-not-allowed">
                            {{ item.faculty.first_name }} {{ item.faculty.middle_name }} {{ item.faculty.last_name }}
                        </p>
                    </template>
                    <template #marks="{item}">
                        {{ item.submitted_students?.[0]?.marks ?? "N/A" }} / {{ item.total_marks }}
                    </template>
                    <template #remark="{item}">
                        {{ item.submitted_students?.[0]?.remark ?? "-" }}
                    </template>
                    <template #action="{item}">
                        <a class="col-span-2 inline-flex
                            items-center px-4 py-2 bg-gray-800
                            border border-transparent rounded-md
                            font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700
                            active:bg-gray-900 focus:outline-none focus:border-gray-900
                            focus:shadow-outline-gray transition ease-in-out duration-150 justify-center"
                           :href="item.submitted_students?.[0]?.file" target="_blank"
                           v-if="item.submitted_students?.[0]?.file"
                        >
                            View {{ type }}
                        </a>
                        <Button v-else>
                            View {{ type }}
                        </Button>
                    </template>
                </Table>
            </div>

            <div class="col-span-5" v-if="presentation">
                <div class="flex space-x-4 justify-between items-center">
                    <p class="font-semibold text-3xl text-gray-800 leading-tight">{{ presentation.title }}</p>
                    <p>{{ presentation.done_marking }} student submitted out of {{ presentation.total_students }}</p>
                    <a class="col-span-2 inline-flex
                            items-center px-4 py-2 bg-gray-800
                            border border-transparent rounded-md
                            font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700
                            active:bg-gray-900 focus:outline-none focus:border-gray-900
                            focus:shadow-outline-gray transition ease-in-out duration-150 justify-center"
                       :href="presentation?.file" target="_blank"
                    >
                        View Referral document
                    </a>
                </div>
                <Table :fields="studentsFields"
                       :items="students"
                       :canView="true"
                       :empty_message="`Students not found`"
                >
                    <template #remark="{item}">
                        <div v-if="item?.submission">
                            {{ item.submission?.remark }}
                        </div>
                        <p v-else>-</p>
                    </template>
                    <template #marks="{item}">
                        <div v-if="item?.submission">
                            {{ item.submission?.marks }} / {{ presentation.total_marks }}
                        </div>
                        <p v-else>-</p>
                    </template>
                    <template #name="{item}">
                        <div>
                            {{ item.first_name }} {{ item.middle_name }} {{ item.last_name }}
                            <p v-if="item?.submission" class="text-green-600 text-sm mt-1">Submitted on
                                {{ tableDate(item?.submission?.created_at) }}</p>
                            <p v-else class="text-red-600 text-sm mt-1">Not submitted yet</p>
                        </div>
                    </template>
                    <template #action="{item}">
                        <div class="flex gap-2">
                            <a v-if="item?.submission" class="col-span-2 inline-flex
                            items-center px-4 py-2 bg-gray-800
                            border border-transparent rounded-md
                            font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700
                            active:bg-gray-900 focus:outline-none focus:border-gray-900
                            focus:shadow-outline-gray transition ease-in-out duration-150 justify-center"
                               :href="item?.submission?.file" target="_blank"
                            >View

                            </a>
                            <Button v-else disabled="true">
                                View
                            </Button>

                            <inertia-link
                                :href="`${route(`internal.admission.view`, [branch.id, item?.admission?.id])}?activeTab=Performance`">
                                <Button>Performance</Button>
                            </inertia-link>
                        </div>
                    </template>
                </Table>

            </div>
        </div>
    </Internal>
</template>
<script setup>
import Internal from "@/Pages/Internal/Internal.vue";
import {usePage} from "@inertiajs/inertia-vue3";
import Table from "@/Components/Table.vue";
import Button from "@/Components/Button.vue";
import {computed} from "vue";
import {tableDate} from "../../../../../Utils/Common";
import {capitalize} from "@vue/shared";
import {hasRole} from "../../../../../Utils/checkPermission";
import BreadcrumbsComponent from "@/Components/BreadcrumbsComponent.vue";

const presentations = usePage().props.value.presentations ?? [];
const admission = usePage().props.value?.admission ?? {};
const branch = usePage().props.value?.branch ?? {};
const auth = usePage().props.value?.auth ?? {};
const presentation = usePage().props.value?.presentation ?? null;
const type = usePage().props.value?.type ?? null;

const _type = computed(() => `${capitalize(type)}${type == 'bonus' ? '' : 's'}`)
const students = computed(() => {
    let _students = presentation?.submitted_students ?? [];
    _students = _students.map((item) => {
        const {student, ...rest} = item;
        return {...student, submission: rest};
    })
    return [..._students, ...presentation.not_submitted_students];
})
const fields = [
    {'key': 'title', 'label': 'title'},
    {'key': 'teacher', 'label': 'Teacher'},
    {'key': 'marks', 'label': 'Marks'},
    {'key': 'remark', 'label': 'Remark'},
    {'key': 'action', 'label': 'Action'}
];
const studentsFields = [
    {'key': 'name', 'label': 'Student'},
    {'key': 'roll_no', 'label': 'Roll No'},
    {'key': 'marks', 'label': 'Marks'},
    {'key': 'remark', 'label': 'Remark'},
    {'key': 'action', 'label': 'Action'}
];
const pages = [
    {name: 'Admissions', href: route('internal.admission.list',branch.id), current: false},
    {
        name: ` ${admission?.student?.first_name} ${admission?.student?.last_name}`,
        href: `${route('internal.admission.view', [branch.id, admission.id])}?activeTab=Performance`,
        current: false
    },
    {name: _type.value, current: true},
]
</script>
